import { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { GroupFormType } from '../GroupForm/utils'
import { PrivacyOptions } from '@wellesley/forms'
import SelectWithRadio from 'components/form/SelectWithRadio'
import { LockKeyhole, Link, EarthIcon } from 'lucide-react'

const privacySelect = [
  {
    key: PrivacyOptions.public,
    description: `Open access to content and group members`,
    icon: <EarthIcon />,
  },
  {
    key: PrivacyOptions.private,
    description: `Content and member info are visible to group members only`,
    icon: <LockKeyhole />,
  },
  {
    key: PrivacyOptions.secret,
    description: `Not searchable. Only members can view. Join by invite link only`,
    icon: <Link />,
  },
]

type CmpProps = {
  form: UseFormReturn<GroupFormType>
  title: string
  onChange?: (value: string) => void
}

const PrivacySelect: FC<CmpProps> = ({ form, title, onChange }) => {
  return (
    <SelectWithRadio
      form={form}
      name="privacy"
      title={title}
      options={privacySelect}
      className="mb-xl"
      onChange={onChange}
    />
  )
}

export default PrivacySelect
